module.exports = __webpack_public_path__ + "static/media/icons_arrow_left_right.fe471a1b.svg";